import FloorCreate from './lib/create';
import FloorsTable from './lib/table';
import { useTypedSelector } from 'common/hooks/useTypedSelector';
import AppLoading from 'components/appLoading';
import PageTitle from 'components/pageTitle';

import * as S from './styles';

export default function FloorsPage() {
  const { floorList, editFloor, createFloor, deleteFloor }: any = useTypedSelector((state) => state.Floors);

  return (
    <S.Container>
      <PageTitle title="Floors" />
      <S.Head>
        <FloorCreate />
      </S.Head>
      <FloorsTable menuList={floorList.data} loading={floorList.loading} />

      <AppLoading loading={editFloor.loading || createFloor.loading || deleteFloor.loading} />
    </S.Container>
  );
}
